import { render } from "./Proposal.vue?vue&type=template&id=1534ebf3&scoped=true"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"

import "./Proposal.vue?vue&type=style&index=0&id=1534ebf3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1534ebf3"]])

export default __exports__